import { Briefcase, GraduationCap, Palmtree, Route, Sparkles } from "lucide-react";
import { useApp } from "../context/AppContext";
import { IMAGES } from "../lib/site";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = { palmtree: Palmtree, briefcase: Briefcase, gradcap: GraduationCap, route: Route, sparkles: Sparkles };
const BG = { wisata: IMAGES.scenery, korporat: IMAGES.corporate };
const SPAN = ["md:col-span-7", "md:col-span-5", "md:col-span-4", "md:col-span-4", "md:col-span-4"];

export const Services = () => {
  const { t } = useApp();
  return (
    <section id="layanan" className="border-y border-border bg-secondary/40 py-24 dark:bg-secondary/20 md:py-36" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <SectionHead overline={t.services.overline} title={t.services.title} sub={t.services.sub} testId="services-head" />

        <div className="mt-16 grid grid-cols-1 gap-6 md:mt-20 md:grid-cols-12">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[s.icon];
            const bg = BG[s.key];
            return (
              <Reveal key={s.key} delay={i * 0.06} className={SPAN[i]}>
                <div
                  data-testid={`service-card-${s.key}`}
                  className="group relative flex h-full min-h-[280px] flex-col justify-end overflow-hidden rounded-2xl border border-border bg-card p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl md:min-h-[300px]"
                >
                  {bg && (
                    <>
                      <img
                        src={bg}
                        alt={s.title}
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
                    </>
                  )}
                  <div className="relative">
                    <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${bg ? "bg-white/15 text-white backdrop-blur-sm" : "bg-primary/10 text-primary"}`}>
                      <Icon className="h-6 w-6" />
                    </div>
                    <h3 className={`mt-5 font-display text-2xl font-medium tracking-tight ${bg ? "text-white" : ""}`}>{s.title}</h3>
                    <p className={`mt-2 text-sm leading-relaxed ${bg ? "text-white/80" : "text-muted-foreground"}`}>{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
